import { Company } from "./interfaces";

export const getCompanyNames = (companies: Company[]): string[] =>
  companies.map(({ name }) => name);
